import React from "react";
import { createRoot } from "react-dom/client";
import SessionExpiredModal from "../components-new/error-boundary/SessionExpiredModal";

let modalRoot = null;

export const showSessionExpiredModal = (onLogout, countdown = 3) => {
  if (!modalRoot) {
    const modalContainer = document.createElement("div");
    modalContainer.id = "session-expired-modal-root";
    document.body.appendChild(modalContainer);
    modalRoot = createRoot(modalContainer);
  }

  modalRoot.render(<SessionExpiredModal onLogout={onLogout} countdown={countdown} />);
};

export const hideSessionExpiredModal = () => {
  if (modalRoot) {
    modalRoot.unmount();
    const container = document.getElementById("session-expired-modal-root");
    if (container) {
      container.remove();
    }
    modalRoot = null;
  }
};
